import { FC, useState, useEffect } from 'react';
import { Box, Grid, Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIAutoCompleteInput, SCUIButton } from '../../../../atomic/atoms';
import React from 'react';
import {
    EmailTemplateBuilderServiceQuery,
    LocalizationManagementQuery,
    MasterDataQuery,
} from '../../../../services/query';
import Swal from 'sweetalert2';
import Helper from '../../../../utils/helper';
import { ETBED_SUB_GALLERY } from '../../emailTemplateBuilder.classes';
import { sectionTypes } from '../../EmailTemplateBuilder.config';

interface IProps {
    setSelectedSubSectionList?: any;
}

export const AddOrEditSubSectionDrawer: FC<IProps> = ({ setSelectedSubSectionList }) => {
    const { t } = useTranslation();

    const [findedSection, setFindedSection] = React.useState<any>();
    const [autocompleteData, setAutocompleteData] = useState<any>();
    const [languageList, setLanguageList] = useState<any>();
    const [selectedLanguage, setSelectedLanguage] = useState('tr-TR');
    const [countryList, setCountryList] = useState<any>();
    const [selectedCountry, setSelectedCountry] = useState('TR');
    const [selectedType, setSelectedType] = useState(2);

    useEffect(() => {
        GetLanguageList();
        GetCountryList();
    }, []);

    const GetLanguageList = async () => {
        LocalizationManagementQuery.CultureList().then((res: any) => {
            setLanguageList(res.data);
        });
    };

    const GetCountryList = async () => {
        MasterDataQuery.GetCountryList().then((res: any) => {
            let parseData = res.data.map((item: any) => {
                return {
                    id: item.countryId,
                    key: item.countryKey,
                    name: item.countryCode,
                    dropdownValueText: item.translatedCountryName,
                };
            });
            setCountryList(parseData);
        });
    };

    const selectionHandleChange = (newValue: any) => {
        setFindedSection(newValue);
    };

    const handleaddButton = () => {
        if (findedSection !== undefined) {
            setSelectedSubSectionList(findedSection.content);
        } else {
            Swal.fire('Lütfen bir alt alan seçiniz');
        }
    };

    const handleSearch = (text: any) => {
        let countryCode = Helper.getCountryCodeFromCountryId();
        const parsedLanguageObject = JSON.parse(localStorage.getItem('languageObject') || '{}');
        let request = {
            type: selectedType,
            keyword: text,
            languageCode: parsedLanguageObject.value || parsedLanguageObject.languageCode || 'tr-TR',
            countryCode: countryCode,
            take: 100,
            skip: 1,
        };
        EmailTemplateBuilderServiceQuery.GetSectionData(request).then((res: any) => {
            setAutocompleteData(res.data);
        });
    };

    return (
        <Grid
            className={ETBED_SUB_GALLERY.drawerBody}
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                padding: '16px 4px',
            }}
            size={{
                xs: 12,
                md: 12,
                lg: 12,
                xl: 12,
            }}
        >
            <Grid
                className={ETBED_SUB_GALLERY.fieldCountry}
                style={{ margin: '1rem' }}
                size={{
                    xs: 12,
                    md: 12,
                    lg: 12,
                    xl: 12,
                }}
            >
                {countryList && countryList.length > 0 && (
                    <Autocomplete
                        className={ETBED_SUB_GALLERY.autocompleteCountryRoot}
                        options={countryList}
                        getOptionLabel={(option: any) => option?.dropdownValueText || ''}
                        value={countryList?.find((item: any) => item?.name === selectedCountry) || null}
                        onChange={(_, newValue) => {
                            setSelectedCountry(newValue?.name || 'TR');
                            setFindedSection(undefined);
                            setAutocompleteData([]);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                className={ETBED_SUB_GALLERY.inputAutocompleteCountry}
                                label={t('emailTemplateBuilder.selectCountryName')}
                                size="small"
                                fullWidth
                            />
                        )}
                        disablePortal
                    />
                )}
            </Grid>
            <Grid
                className={ETBED_SUB_GALLERY.fieldLanguage}
                style={{ margin: '1rem' }}
                size={{
                    xs: 12,
                    md: 12,
                    lg: 12,
                    xl: 12,
                }}
            >
                {languageList && languageList.length > 0 && (
                    <Autocomplete
                        className={ETBED_SUB_GALLERY.autocompleteLanguageRoot}
                        options={languageList}
                        getOptionLabel={(option: any) => option.code}
                        value={languageList.find((item: any) => item.code === selectedLanguage) || null}
                        onChange={(_, newValue) => {
                            setSelectedLanguage(newValue?.code || 'tr-TR');
                            setFindedSection(undefined);
                            setAutocompleteData([]);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                className={ETBED_SUB_GALLERY.inputAutocompleteLanguage}
                                label={t('emailTemplateBuilder.selectLanguage')}
                                size="small"
                                fullWidth
                            />
                        )}
                        disablePortal
                    />
                )}
            </Grid>
            <Grid
                className={ETBED_SUB_GALLERY.fieldSectionType}
                style={{ margin: '1rem' }}
                size={{
                    xs: 12,
                    md: 12,
                    lg: 12,
                    xl: 12,
                }}
            >
                <Autocomplete
                    className={ETBED_SUB_GALLERY.autocompleteSectionTypeRoot}
                    options={sectionTypes}
                    getOptionLabel={(option: any) => option.name}
                    value={sectionTypes.find((item: any) => item.id === selectedType) || null}
                    onChange={(_, newValue) => {
                        setSelectedType(newValue?.id || 2);
                        setFindedSection(undefined);
                        setAutocompleteData([]);
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            className={ETBED_SUB_GALLERY.inputAutocompleteSectionType}
                            label={t('emailTemplateBuilder.sectionType')}
                            size="small"
                            fullWidth
                        />
                    )}
                    disablePortal
                />
            </Grid>
            <Grid
                className={ETBED_SUB_GALLERY.fieldSection}
                style={{ margin: '1rem' }}
                size={{
                    xs: 12,
                    md: 12,
                    lg: 12,
                    xl: 12,
                }}
            >
                <Box className={ETBED_SUB_GALLERY.sectionAutocompleteWrap}>
                <SCUIAutoCompleteInput
                    list={autocompleteData || []}
                    onChange={(event: any, newValue: any) => {
                        selectionHandleChange(newValue);
                    }}
                    onChangeTextField={(e: any) => {
                        if (e.target.value.length > 2) {
                            handleSearch(e.target.value);
                        }
                    }}
                    multiple={false}
                    txtPlaceHolder={t('emailTemplateBuilder.addSubsection')}
                    searchValue="key"
                />
                </Box>
            </Grid>
            <Grid
                className={ETBED_SUB_GALLERY.actionsFooter}
                style={{
                    position: 'absolute',
                    bottom: 0,
                    width: 380,
                    marginLeft: '10px',
                    marginBottom: '20px',
                }}
            >
                <SCUIButton
                    className={ETBED_SUB_GALLERY.inputButtonAdd}
                    text={t('general.add')}
                    type="primary"
                    sizeType="default"
                    buttonType="submit"
                    size={'s'}
                    fullwidth
                    onClick={() => handleaddButton()}
                />
            </Grid>
        </Grid>
    );
};
